import { render, staticRenderFns } from "./AthleteVerifiedAssessmentsHistory.vue?vue&type=template&id=2891577e&scoped=true&"
import script from "./AthleteVerifiedAssessmentsHistory.vue?vue&type=script&lang=ts&"
export * from "./AthleteVerifiedAssessmentsHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2891577e",
  null
  
)

export default component.exports